// components/DirectionsPanel.tsx
import React from 'react';
import { FaTimes, FaInfoCircle } from 'react-icons/fa';

interface DirectionsPanelProps {
  isOpen: boolean;
  directions: any;
  totalDistance: number;
  duration: string;
  onClose: () => void;
}

export const DirectionsPanel: React.FC<DirectionsPanelProps> = ({
  isOpen,
  directions,
  totalDistance,
  duration,
  onClose,
}) => {
  if (!isOpen) return null;

  const getInstructions = () => {
    if (directions && directions.features && directions.features[0]) {
      const segments = directions.features[0].properties.segments;
      if (segments && segments[0] && segments[0].steps) {
        return segments[0].steps;
      }
    }
    return [];
  };

  return (
    <div className="w-96 bg-white shadow-lg overflow-y-auto p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-800">Turn-by-Turn Directions</h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
        >
          <FaTimes />
        </button>
      </div>
      
      {directions ? (
        <div className="space-y-4">
          <div className="bg-blue-50 p-3 rounded-lg">
            <p className="text-sm font-medium text-blue-800">Route Summary</p>
            <div className="flex justify-between mt-1">
              <span className="text-sm">Distance: {totalDistance.toFixed(2)} km</span>
              <span className="text-sm">Duration: {duration}</span>
            </div>
          </div>
          
          <div className="space-y-2">
            {getInstructions().map((step: any, idx: number) => (
              <div key={idx} className="flex items-start gap-3 p-2 hover:bg-gray-50 rounded-lg">
                <div className="flex-shrink-0 w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center text-xs font-bold text-gray-600">
                  {idx + 1}
                </div>
                <div className="flex-1">
                  <p className="text-sm">{step.instruction}</p>
                  <p className="text-xs text-gray-500">
                    {(step.distance / 1000).toFixed(1)} km · {Math.round(step.duration / 60)} min
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center text-gray-500 py-8">
          <FaInfoCircle className="text-4xl mx-auto mb-2" />
          <p>No directions available</p>
          <p className="text-sm">Add points to generate directions</p>
        </div>
      )}
    </div>
  );
};